import {
    Callout,
    Card,
    CardContent,
    CardTitle,
    ConfirmActionButton,
    Icon,
    NavPanes
} from "@tv2no/ui-react";
import React, { useState } from "react";
import { getImportEntryLog } from "../../../../../api/services/taxYear";
import { ImportDetails } from "../../../../../components/import/ImportDetails";
import { ImportLogTable } from "../../../../../components/import/ImportLogTable";

export const ActiveImport = ({ taxYear, entry, onAbortImport }) => {
    const [logList, setLogList] = useState(null);
    const [activeKey, setActiveKey] = useState(1);

    const handleSetActiveKey = (key) => {
        if (parseInt(key, 10) === 2) {
            getImportEntryLog(entry.id).then((response) => {
                setLogList(response);
            });
        }
        setActiveKey(key);
    };

    return entry && !entry.finished && taxYear.year !== entry.year ? (
        <Card>
            <CardTitle title="Import" />
            <CardContent>
                <Callout color="warning">
                    Det pågår allerede en import av datagrunnlag for skatteåret {entry.year}.
                </Callout>
            </CardContent>
        </Card>
    ) : entry && !entry.finished ? (
        <Card>
            <CardTitle title="Import">
                {!entry.finished && <Icon color="primary" name="refresh" rotate />}
            </CardTitle>
            <NavPanes embedded activeKey={activeKey} onChange={handleSetActiveKey}>
                <NavPanes.Pane paneKey={1} label="Detaljer" icon="clock">
                    <CardContent>
                        <ImportDetails entry={entry} />
                    </CardContent>
                </NavPanes.Pane>
                <NavPanes.Pane paneKey={2} label="Logg" icon="align-left">
                    <CardContent>
                        <ImportLogTable log={logList} />
                    </CardContent>
                </NavPanes.Pane>
            </NavPanes>
            <CardContent border="top">
                <ConfirmActionButton
                    fill={false}
                    popup
                    label="Avbryt import"
                    size="small"
                    question="Er du sikker på at du vil avbryte importen?"
                    onConfirm={onAbortImport}
                />
            </CardContent>
        </Card>
    ) : null;
};
